import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setMensagem('');
    setLoading(true);

    try {
      await api.post('/auth/esqueci-senha', { email });

      // mesmo se o e-mail não existir, o backend responde OK (motivo: segurança)
      setMensagem('Se este e-mail estiver cadastrado, a senha será enviada em instantes.');
    } catch (err) {
      setErro(
        err?.response?.data?.erro ||
        err?.message ||
        'Não foi possível processar sua solicitação.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        background: 'linear-gradient(270deg, #2196f3, #ffeb3b, #2196f3)',
        backgroundSize: '600% 600%',
        animation: 'gradientShift 12s ease infinite',
        padding: { xs: 2, sm: 4 },
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: { xs: 3, sm: 5 },
          width: '100%',
          maxWidth: 400,
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Esqueci minha senha
        </Typography>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Informe o e-mail de acesso ao painel. Se ele estiver cadastrado, você receberá sua senha.
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="E-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Email />
                </InputAdornment>
              ),
            }}
            disabled={loading}
          />

          {mensagem && (
            <Typography color="primary" variant="body2" sx={{ mt: 1 }}>
              {mensagem}
            </Typography>
          )}
          {erro && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {erro}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3, py: 1.5, fontWeight: 'bold' }}
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} color="inherit" />}
          >
            {loading ? 'Enviando...' : 'Enviar senha por e-mail'}
          </Button>

          <Button
            type="button"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => navigate('/login')}
          >
            Voltar para o login
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
